import React, { useState } from "react";
import WelcomeScreen from "./WelcomeScreen/WelcomeScreen";
import PreAssessment from "./PreAssessment";
import Success from "./PreAssessmentSuccess/Success";
import { PRE_ASSESSMENT_SCREENS } from "../../../helpers/constants";

const Home = () => {
  const [currentScreen, setCurrentScreen] = useState(
    PRE_ASSESSMENT_SCREENS.WELCOME
  );

  const handleNext = () => {
    if (currentScreen === PRE_ASSESSMENT_SCREENS.WELCOME) {
      setCurrentScreen(PRE_ASSESSMENT_SCREENS.PREASSESSMENT);
    } else if (currentScreen === PRE_ASSESSMENT_SCREENS.PREASSESSMENT) {
      setCurrentScreen(PRE_ASSESSMENT_SCREENS.SUCCESS);
    }
  };
  return (
    <div className="pre-assessment-home">
      <div className="assessment-modal">
        {currentScreen === PRE_ASSESSMENT_SCREENS.WELCOME && (
          <WelcomeScreen handleNext={handleNext} />
        )}
        {currentScreen === PRE_ASSESSMENT_SCREENS.PREASSESSMENT && (
          <PreAssessment handleNext={handleNext} />
        )}
        {currentScreen === PRE_ASSESSMENT_SCREENS.SUCCESS && <Success />}
      </div>
    </div>
  );
};

export default Home;
